import React from 'react';
const formatValue = value => !value || isNaN(value) ? '-' : `${Math.floor(value)} %`;
const Row = ({
  employee,
  accent_color
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "list-row list-item",
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, employee.ranking, ". "), employee.name ? employee.name : employee.id), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, formatValue(employee.value)));
};
export default Row;